// components/PagosTable.js
import { 
  Table, TableBody, TableCell, TableContainer, 
  TableHead, TableRow, Paper, Chip, IconButton, 
  TextField, InputAdornment, Box, Typography 
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import PaymentIcon from '@mui/icons-material/Payment';
import { formatImporte, getMedioPagoName } from '../utils/formatters';

export const PagosTable = ({ 
  pagos, 
  editandoId, 
  nuevoImporte,
  loading,
  onStartEdit, 
  onSaveEdit,  // Ahora hace el PUT directamente
  onCancelEdit,
  onImporteChange,
  canEdit = (medio_pago) => medio_pago !== 6 && medio_pago !== 11 && medio_pago !== 10 && medio_pago !== 12
}) => {
  return (
    <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 3 }}>
      <Table>
        <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
          <TableRow>
            <TableCell><strong>Medio de Pago</strong></TableCell>
            <TableCell align="right"><strong>Importe</strong></TableCell>
            <TableCell align="center"><strong>Detalle</strong></TableCell>
            <TableCell align="center"><strong>Acciones</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {pagos.map((pago) => (
            <TableRow 
              key={pago.id} 
              hover
            >
              <TableCell>
                <Chip 
                  icon={<PaymentIcon />} 
                  label={pago.nombre || getMedioPagoName(pago.medio_pago)} 
                  color={pago.medio_pago === 6 ? "primary" : pago.medio_pago === 10 ? "success" : "default"}
                  size="small"
                  sx={{ fontWeight: 500 }}
                />
              </TableCell>
              <TableCell align="right">
                {editandoId === pago.id ? (
                  <TextField
                    value={nuevoImporte}
                    onChange={onImporteChange}
                    size="small"
                    type="text"
                    disabled={loading}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    }}
                    autoFocus
                    sx={{ width: 150 }}
                  />
                ) : (
                  <Typography fontWeight="bold" color="#2E7D32">
                    ${formatImporte(pago.importe)}
                  </Typography>
                )}
              </TableCell>
              <TableCell align="center">
                <Typography variant="body2" color="textSecondary">
                  {pago.detalle || '-'}
                </Typography>
              </TableCell>
              <TableCell align="center">
                {canEdit(pago.medio_pago) ? (
                  editandoId === pago.id ? (
                    <Box>
                      <IconButton 
                        onClick={() => onSaveEdit(pago.id, parseFloat(nuevoImporte.replace(',', '.')))}
                        color="success"
                        size="small"
                        title="Guardar cambio"
                        disabled={loading}
                      >
                        <SaveIcon />
                      </IconButton>
                      <IconButton 
                        onClick={onCancelEdit}
                        color="error"
                        size="small"
                        title="Cancelar"
                        disabled={loading}
                      >
                        <CancelIcon />
                      </IconButton>
                    </Box>
                  ) : (
                    <IconButton 
                      onClick={() => onStartEdit(pago)}
                      color="primary"
                      size="small"
                      title="Editar monto"
                      disabled={loading}
                    >
                      <EditIcon />
                    </IconButton>
                  )
                ) : (
                  <Chip 
                    label="No editable" 
                    size="small" 
                    variant="outlined"
                    color="info"
                    sx={{ fontStyle: 'italic' }}
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};